export default "__VITE_ASSET__e6e81e8b__"